
//验证手机号码
export const isMobile = {
  getMessage:field => field + '必须是11位手机号码',
  validate: value => {
    return value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  }
}




// WEBPACK FOOTER //
// ./src/validator/modules/demoValidat.js